import CategoryService from 'src/lib/api/category.service';

export async function searchCategories({ commit }, { params }) {
  const response = await CategoryService.searchCategories({ params });
  if (response.status === 200) {
    commit('updateCategories', { categories: response.data.data });
    commit('updateMeta', {
      meta: {
        next: response.data.next,
        previous: response.data.previous,
        rowCount: response.data.total,
      },
    });
  }
}

export async function getCategory({ commit }, { id }) {
  const response = await CategoryService.getCategory({ id });
  if (response.status === 200) {
    commit('updateCurrentCategory', { category: response.data });
  }
}

export async function createCategory(context, { category }) {
  await CategoryService.createCategory({ category });
}

export async function updateCategory(context, { id, category }) {
  await CategoryService.updateCategory({ id, category });
}

export async function deleteCategory(context, { id }) {
  await CategoryService.deleteCategory({ id });
}

export async function fetchAvailableCategories({ commit }) {
  const response = await CategoryService.searchCategories({ params: { limit: -1 } });
  if (response.status === 200) {
    commit('updateAvailableCategories', { categories: response.data.data });
  }
}
